import { render } from "./Stripe.vue?vue&type=template&id=3e2497c7"
import script from "./Stripe.vue?vue&type=script&lang=js"
export * from "./Stripe.vue?vue&type=script&lang=js"
script.render = render

export default script